import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '#shared/api/requests';
import {
    type OpenApiImportYmlSetupDeleteRequest,
    type OpenApiImportYmlSetupDeleteResponseSuccess,
    type OpenApiImportYmlSetupGetRequest,
    type OpenApiImportYmlSetupGetResponseSuccess,
    type OpenApiImportYmlSetupRequest,
    type OpenApiImportYmlSetupResponseSuccess,
} from '#shared/api/schema';

const ymlApi = createApi({
    name: 'entities/integration/api/ymlApi',
    baseQuery: createBaseQuery(apiV1Request),
    endpoints: (builder) => {
        return {
            postSetup: builder.mutation<OpenApiImportYmlSetupResponseSuccess, OpenApiImportYmlSetupRequest>({
                query: (payload) => {
                    return {
                        url: '/integrations/yml/setup',
                        method: 'POST',
                        body: payload,
                    };
                },
            }),
            deleteSetup: builder.mutation<
                OpenApiImportYmlSetupDeleteResponseSuccess,
                OpenApiImportYmlSetupDeleteRequest
            >({
                query: () => {
                    return {
                        url: '/integrations/yml/setup',
                        method: 'DELETE',
                    };
                },
            }),
            getSetup: builder.query<OpenApiImportYmlSetupGetResponseSuccess, OpenApiImportYmlSetupGetRequest>({
                query: () => {
                    return {
                        url: '/integrations/yml/setup',
                        method: 'GET',
                    };
                },
            }),
        };
    },
});

export const integrationYamlPostSetup = ymlApi.endpoints.postSetup.mutate;
export const integrationYamlDeleteSetup = ymlApi.endpoints.deleteSetup.mutate;
export const integrationYamlGetSetup = ymlApi.endpoints.getSetup.query;
export const useIntegrationYamlGetSetup = ymlApi.useGetSetupQuery;
